import { HomeBookingScreen, HomeBookingsScreen } from './home/bookings';
import { HomeConsentDialog } from './home/consent';
import { HomeCustomScreen } from './home/custom';
import { HomeEventScreen, HomeReviewsScreen } from './home/event';
import { HomePastScreen, HomeSearchScreen } from './home/events';
import { HomeFriendsScreen } from './home/friends';
import { HomeGiftcardB2BScreen, HomeGiftcardScreen, HomeRedeemCodeScreen } from './home/giftcard';
import { homeShowInbox } from './home/inbox';
import { HomeInviteScreen } from './home/invite';
import { HomeMembershipScreen } from './home/membership';
import { HomePlayerScreen } from './home/player';
import { HomeProducerScreen } from './home/producer';
import { HomeProfileScreen } from './home/profile';
import { HomeSignupScreen } from './home/signup';
import { HomeSubscribeScreen } from './home/subscribe';
import { HomeTagScreen } from './home/tag';
import { HomeVenueScreen } from './home/venue';
import { aInitTrack } from './lib/mdl/a-track';
import { FBuiltinPage, FRoute } from './lib/mdl/f-route';
import { hasSubscriptions } from './lib/me/home';
import { meAutoLogin, the_login_scope, the_reset_token } from './lib/me/login';
import { UIBaseInput } from './lib/ui/component/input-base';
import { $composer } from './lib/ui/composer';
import { $el } from './lib/ui/elements';
import { $recaptcha } from './lib/ui/media/recaptcha';
import { UIScreen } from './lib/ui/screen';
import { $analytics } from './lib/y/analytics';
import { $log, xavis_experiments } from './lib/y/debug';
import { $location, YLocation, YLocationParams, YPushSpec, YRoute } from './lib/y/location';
import { $storage } from './lib/y/storage';
import { y_ready, yLoadAsyncScript } from './lib/y/util';

UIBaseInput.default_kind = 'k-line';
$location.title_suffix = 'Abundo';

let show_consent_dialog = $storage.getString('abundo_consent_done') !== 'yes';

if(xavis_experiments) {
    show_consent_dialog = false;
} else {
    if($storage.getString('abundo_consent_accepted') === 'yes') {
        $analytics.initSegment('E4a3RaukNyV9Epw68sDko1qZsdlC9fx5');
    } else {
        $analytics.preInitSegment('E4a3RaukNyV9Epw68sDko1qZsdlC9fx5');

        const element = $el.DIV();
        element.id = 'consent-container';
        document.body.appendChild(element);

        (window as any).consentManagerConfig = (exports: any) => {
            const React = exports.React
            const inEU = exports.inEU
            $log('app', 'inEU', inEU());

            const bannerContent = React.createElement(
                'span',
                null,
                'We use cookies (and other similar technologies) to collect data to improve your experience on our site. By using our website, you՚re agreeing to the collection of data as described in our',
                ' ',
                React.createElement(
                    'a',
                    { href: '/docs/legal/website-data-collection-policy/', target: '_blank' },
                    'Website Data Collection Policy'
                ),
                '.'
            )
            const bannerSubContent = 'You can change your preferences at any time.'
            const preferencesDialogTitle = 'Website Data Collection Preferences'
            const preferencesDialogContent =
                'We use data collected by cookies and JavaScript libraries to improve your browsing experience, analyze site traffic, deliver personalized advertisements, and increase the overall performance of our site.'
            const cancelDialogTitle = 'Are you sure you want to cancel?'
            const cancelDialogContent =
                'Your preferences have not been saved. By continuing to use our website, you՚re agreeing to our Website Data Collection Policy.'

            return {
                container: '#consent-container',
                writeKey: 'E4a3RaukNyV9Epw68sDko1qZsdlC9fx5',
                shouldRequireConsent: () => show_consent_dialog,
                bannerContent: bannerContent,
                bannerSubContent: bannerSubContent,
                preferencesDialogTitle: preferencesDialogTitle,
                preferencesDialogContent: preferencesDialogContent,
                cancelDialogTitle: cancelDialogTitle,
                cancelDialogContent: cancelDialogContent
            }
        }
        yLoadAsyncScript('https://unpkg.com/@segment/consent-manager@5.3.0/standalone/consent-manager.js');
    }
}

$recaptcha.init();

function calcBuiltinScreen(builtin: FBuiltinPage, p: { [key: string]: string }): (m: YLocationParams) => UIScreen | undefined {
    switch(builtin) {
        case 'booking':
            return m => new HomeBookingScreen(m.booking_part_id!);
        case 'bookings':
            return () => new HomeBookingsScreen;
        case 'event':
            return m => new HomeEventScreen(m.city_slug!, m.event_slug!, m.flow, m.event_list_id);
        case 'player':
            return m => new HomePlayerScreen(m.city_slug!, m.event_slug!, m.master_url, m.position);
        case 'reviews':
            return m => new HomeReviewsScreen(m.city_slug!, m.event_slug!);
        case 'past':
            return m => new HomePastScreen(p.year, m.tag_id, m.city_slug, m.genre_slug);
        case 'signup':
            return m => new HomeSignupScreen(false, m.gc_code, m.origin)
        case 'subscribe':
            return m => new HomeSubscribeScreen(m.plan);
        case 'profile':
            return () => new HomeProfileScreen;
        case 'membership':
            return () => new HomeMembershipScreen;
        case 'invite':
            return () => new HomeInviteScreen;
        case 'giftcard':
            return () => new HomeGiftcardScreen;
        case 'giftcard_b2b':
            return () => new HomeGiftcardB2BScreen;
        case 'producer':
            return m => new HomeProducerScreen(m.producer_slug!);
        case 'venue':
            return m => new HomeVenueScreen(m.city_slug!, m.venue_slug!);
        case 'redeem_code':
            return m => new HomeRedeemCodeScreen(m.gc_code);
        case 'search':
            return m => new HomeSearchScreen({ text: m.search_text, venue_id: m.venue_id, producer_id: m.producer_id, tag_id: m.tag_id, date: m.date_filter, from: m.from, to: m.to });
        case 'tag':
            return m => new HomeTagScreen(m.tag_slug!);
        case 'friends':
            return () => new HomeFriendsScreen;
        case 'preview_page':
            return m => new HomeCustomScreen(m.page_id!, false, true);
    }
}

function calcRoute(r: FRoute): YRoute | undefined {
    const path = r.path.split('/').filter(c => c);
    let match: ((l: YLocation | YPushSpec) => boolean) | undefined;

    try {
        const match_flags = Object.keys(r.match_flags);
        if(match_flags.length) {
            match = l => {
                for(const f of match_flags) {
                    if(f == 'logged_in' && !the_login_scope)
                        return false;
                    if(f == 'logged_out' && the_login_scope)
                        return false;
                    if(f == 'subscriptions' && !hasSubscriptions())
                        return false;
                    if(f == 'no_subscriptions' && hasSubscriptions() && !l.params.resubscribe)
                        return false;
                    if(f == 'xavi' && !xavis_experiments)
                        return false;
                }

                return true;
            }
        }

        switch(r.target_type) {
            case 'page':
                return { path: path, match: match, screen: m => new HomeCustomScreen(r.target_page_id!, m.onboarding == true, false) };
            case 'builtin':
                return { path: path, match: match, screen: calcBuiltinScreen(r.target_builtin!, r.parameters) };
            case 'client_redirect':
                return { path: path, match: match, redirect: r.target_url?.split('/').filter(c => c) };
        }
    } catch {}

    $log('app', 'can\'t process route', r);

    return;
}

const routes: YRoute[] = [];

for(const r of window.ab_routes) {
    const route = calcRoute(r);
    route && routes.push(route);
}

routes.push({
    path: ['login'],
    screen: () => new HomeSignupScreen(true)
}, {
    path: ['password_reset'],
    screen: () => new HomeSignupScreen(false, undefined, undefined, false, true)
});

routes.push({ redirect: [] });

const query = $location.getCurrentQuery();
aInitTrack(!query.as_user);

const login_response = meAutoLogin('home', { codes: window.ab_codes }, query.as_user, query.reset);

y_ready.then(() => {
    if(show_consent_dialog) {
        new HomeConsentDialog().present();
    }

    login_response.then(() => {
        $location.on_navigation = () => {
            if(the_login_scope)
                homeShowInbox();
        };
        $location.init(routes, '/', $composer);
        if(the_reset_token)
            $location.navigate(['password_reset']);
    });

    // SERVICE WORKER EXPERIMENT
    // if(xavis_experiments) {
    //     $worker.register('/home-sw.min.js');
    // }

    // LONG POLL EXPERIMENT
    // if(xavis_experiments) {
    //     $http.GET('/api/v1/test/long_poll').then(r => {
    //         $log('long_poll ended', r);
    //     }, () => {
    //         $log('long_poll failed');
    //     });
    // }
});
